import React from 'react';
import { Box, Container, Grid, Typography, Paper } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function Features() {
  const items = [
    { title: 'Custom AI Solutions', desc: 'Tailored solutions for your business problems.' },
    { title: 'Data Engineering', desc: 'Scalable data pipelines and architectures.' },
    { title: 'Cloud Integration', desc: 'Deploy and scale on major cloud providers.' },
  ];

  return (
    <Box sx={{ py: 6 }}>
      <Container>
        <Grid container spacing={3}>
          {items.map((it, idx) => (
            <Grid item xs={12} md={4} key={idx}>
              <Paper elevation={1} sx={{ p: 3, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <CheckCircleIcon color="primary" />
                  <Typography variant="h6">{it.title}</Typography>
                </Box>
                <Typography color="text.secondary" sx={{ mt: 1 }}>{it.desc}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
